export enum SnApplianceCapacityStatus {
  Unknown = 'unknown',
  UpdatesPending = 'updates_pending',
  Healthy = 'healthy',
  Oversubscribed = 'over_subscribed',
}
